import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ImTelegram} from "react-icons/im";
import {
  AiFillGithub, 
  AiFillMail

} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Bechir Chermiti</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} BC</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/Chermitifx"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/bechir-chermiti-5410a1166"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
               href="https://t.me/+21623081229"

                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <ImTelegram />
              </a>
            </li>
            
            {/* <li className="social-icons">
              <a
                href="https://www.instagram.com/bechirchermiti"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li> */}

            <li className="social-icons">
              <a
                href="mailto:chermitibech@gmail.com"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillMail />
              </a>
            </li>

          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
